import CustomNotificationBanner from "../ui/CustomNotificationBanner/CustomNotificationBanner";

export function OtpBlockBanner({
  countdown,
  title = "OTP Verification Blocked",
  message,
  fullWidth = false,
}) {
  return (
    <div className={fullWidth ? "mb-6" : "mb-6 flex justify-center"}>
      <CustomNotificationBanner
        variant="error"
        title={title}
        message={message ?? `Too many failed attempts. Try again in ${countdown}.`}
        withCloseButton={false}
        {...(!fullWidth && { maw: 440 })}
      />
    </div>
  );
}
